<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">{{ pageTitle }}</h1>
        <p class="nd-page-kicker">Registre medicamentos e sintomas para apoiar alertas clínicos.</p>
      </div>
    </header>

    <v-card class="nd-section-card">
      <v-form ref="allergyForm" v-model="formValid">
        <div class="nd-table-toolbar">
          <div>
            <div class="nd-table-toolbar__title">Dados da alergia</div>
            <div class="nd-table-toolbar__subtitle">Informações usadas nas fichas de paciente.</div>
          </div>
        </div>
        <div class="nd-form-grid">
          <v-text-field
            id="name"
            label="Nome"
            v-model="allergy.name"
            :rules="[rules.required]"
            outlined
            dense
           hide-details="auto"></v-text-field>
          <div></div>
          <v-combobox
            id="medicines"
            label="Medicamentos"
            v-model="allergy.medicines"
            outlined
            dense
            multiple
            chips
            small-chips
            deletable-chips
            hint="Pressione Enter para adicionar"
            persistent-hint
           hide-details="auto"></v-combobox>
          <v-combobox
            id="symptoms"
            label="Sintomas"
            v-model="allergy.symptoms"
            outlined
            dense
            multiple
            chips
            small-chips
            deletable-chips
            hint="Pressione Enter para adicionar"
            persistent-hint
           hide-details="auto"></v-combobox>
        </div>
        <div class="nd-form-actions">
          <v-btn id="btnCancel" type="button" color="primary" outlined elevation="0" @click="$router.push('/alergias')">
            Voltar
          </v-btn>
          <v-btn id="btnSave" type="button" color="primary" elevation="0" @click="saveAllergy" :loading="loadingSave">
            Salvar
          </v-btn>
        </div>
      </v-form>
    </v-card>

    <v-overlay :value="loadingPage">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default {
  name: "AllergiesDetails",

  data: () => ({
    allergy: {
      id: null,
      name: "",
      medicines: [],
      symptoms: [],
    },

    loadingPage: false,
    loadingSave: false,
    formValid: false,

    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),

  computed: {
    pageTitle() {
      return this.allergy.id ? 'Detalhes da Alergia' : 'Nova Alergia';
    },
    breadcrumbs() {
      const currentItemText = this.allergy.id ? 'Detalhes da Alergia' : 'Nova Alergia';
      return [
        { text: 'Homepage', disabled: false, to: '/home', exact: true },
        { text: 'Alergias', disabled: false, to: '/alergias', exact: true },
        { text: currentItemText, disabled: true, exact: true },
      ];
    }
  },

  async created() {
    this.loadingPage = true;
    const allergyId = this.$route.params.id;

    if (allergyId) {
      await this.loadAllergy(allergyId);
    }
    this.loadingPage = false;
  },

  methods: {
    async loadAllergy(id) {
      try {
        const response = await axios.get(`/allergies/${id}`);
        const data = response.data.data;
        this.allergy = {
          id: data.id,
          name: data.name,
          medicines: data.medicines || [],
          symptoms: data.symptoms || [],
        };
      } catch (error) {
        console.error('Erro ao carregar detalhes da alergia:', error);
        this.$dialog.notify.error('Erro ao carregar detalhes da alergia.', { position: 'top-right', timeout: 5000 });
      }
    },

    async saveAllergy() {
      if (this.$refs.allergyForm.validate()) {
        this.loadingSave = true;
        try {
          const payload = {
            name: this.allergy.name,
            medicines: this.allergy.medicines,
            symptoms: this.allergy.symptoms,
          };

          if (this.allergy.id) {
            await axios.patch(`/allergies/${this.allergy.id}`, { ...payload, operation: "update" });
            this.$dialog.notify.success('Alergia atualizada com sucesso!', { position: 'top-right', timeout: 3000 });
          } else {
            const response = await axios.post('/allergies', payload);
            this.$dialog.notify.success('Alergia criada com sucesso!', { position: 'top-right', timeout: 3000 });
            this.$router.replace(`/alergias/${response.data.data.id}`);
          }
        } catch (error) {
          console.error('Erro ao salvar alergia:', error);
          this.$dialog.notify.error('Erro ao salvar alergia. Verifique os dados.', { position: 'top-right', timeout: 5000 });
        } finally {
          this.loadingSave = false;
        }
      }
    },
  },
};
</script>
